import { Card, Tabs, Table } from "@arco-design/web-react";
import { InputNumber } from "@/components/Numeric";
import { Number } from "@/components/Numeric";
import { useCallback, useEffect, useState } from "react";
import { ReportAPI } from "@/apis/report";
import _ from "lodash";

const TabPane = Tabs.TabPane;

export const SalesForecast = () => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const getSalesItems = useCallback(async () => {
        const res = await ReportAPI.getSalesItems(page);
        setData(res.records);
        setTotal(res.total);
    }, [page])

    const updateForecast = async (itemId, val) => {
        await ReportAPI.updateItemForecast(itemId, {
            forecast: val
        })
        let newData = _.slice(data);
        _.find(newData, o => o.itemId === itemId).forecast = val;
        setData(newData);
    }

    const updateQtyOnHand = async (itemId, val) => {
        await ReportAPI.updateItemForecast(itemId, {
            qtyOnHand: val
        })
        let newData = _.slice(data);
        _.find(newData, o => o.itemId === itemId).qtyOnHand = val;
        setData(newData);
    }

    useEffect(() => {
        getSalesItems();
    }, [getSalesItems])

    return (
        <Card title="Sales Forecast">
            <Tabs defaultActiveTab="1">
                <TabPane key="1" title="Sales Items">
                    <Table rowKey="itemId" columns={[{
                        title: "Part Number",
                        dataIndex: "itemNo"
                    }, {
                        title: "Part Name",
                        dataIndex: "itemName"
                    }, {
                        title: "Description",
                        dataIndex: "description"
                    }, {
                        title: "Forecast",
                        render: (col, record) => <InputNumber value={record.forecast} onBlur={(e) => updateForecast(record.itemId, e.target.value)} />
                    }, {
                        title: "Safety Level",
                        render: (col, record) => <Number value={record.safetyLevel} />
                    }, {
                        title: "Qty Onhand",
                        render: (col, record) => <InputNumber value={record.qtyOnHand} onBlur={(e) => updateQtyOnHand(record.itemId, e.target.value)} />
                    }, {
                        title: "Open SO",
                        render: (col, record) => <Number value={record.openSO} />
                    }, {
                        title: "Qty Available",
                        render: (col, record) => <Number value={record.qtyAvailable} />
                    }, {
                        title: "Open PO/WO",
                        render: (col, record) => <Number value={record.openPOWO} />
                    }, {
                        title: "Net Qty",
                        render: (col, record) => <Number value={record.netQty} />
                    }]}
                        data={data} scroll={{ y: 'calc(100vh - 280px)' }} pagination={{ total, current: page }}
                        onChange={(pagination) => setPage(pagination.current)}
                    />
                </TabPane>
            </Tabs>
        </Card>
    )
}